import React from 'react';

import Text from 'components/Text';

import { useContent } from './hooks';
import Item from './Item';
import { Title, Preamble, Version, Wrapper } from './styles';

const Data = () => {
  const { title, preamble, date, version, items } = useContent();

  return (
    <>
      <Title>{title}</Title>
      <Preamble>{preamble}</Preamble>
      <Text.Small>{date}</Text.Small>
      <Version>{version}</Version>
      <Wrapper>
        {items.map((item) => (
          <Item key={item.id} {...item} />
        ))}
      </Wrapper>
    </>
  );
};

export default Data;
